import { Stack,  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button, } from '@mui/material';
import { FC, useState } from 'react';

import {
  DefaultMessageField,
  defaultMessages,
} from '@features/employerAccount';
import { getCookie } from '@utils/getCookie';
import { white } from '@styles/colors';

import TemplateUpdateDefaultMessageModal from './TemplateUpdateDefaultMessageModal';
import { EnterpriseTemplate } from '../types';
import ConfirmationModal from './ConfirmationModal';
import parse from 'html-react-parser';
import { Box } from '@mui/system';

type DetailRow = {
  label: string;
  messageKey: DefaultMessageField;
};

const detailRows: DetailRow[] = [
  {
    label: 'Request More Info',
    messageKey: 'default_request_more_info_message',
  },
  { label: 'Schedule Interview', messageKey: 'default_interview_message' },
  {
    label: 'Invite to Interview Block',
    messageKey: 'default_interview_block_message',
  },
  {
    label: 'Invite to Open Interview',
    messageKey: 'default_open_interview_message',
  },
  {
    label: 'Interview Confirmed',
    messageKey: 'default_interview_confirm_message',
  },
  { label: 'Save Application', messageKey: 'default_saved_message' },
  { label: 'Decline Application', messageKey: 'default_declined_message' },
  { label: 'Job Offer', messageKey: 'default_hire_message' },
  { label: 'Archive Application', messageKey: 'default_archive_message' },
];
type TemplateApplicationResponsesTabProps = {
  templateData: EnterpriseTemplate
}
const TemplateApplicationResponsesTab: FC<TemplateApplicationResponsesTabProps> = ({ templateData }) => {
   const [expanded, setExpanded] = useState<string | false>(false);
  const dontShowWarningPopup = getCookie('dontShowWarningPopup');
  const isAppliedChanges = templateData.apply_changes && !dontShowWarningPopup;
  const [selectedField, setSelectedField] =
    useState<DefaultMessageField | null>(null);
  const [pendingFeild, setPendingFeild] = useState<DefaultMessageField | null>(null);
  const [selectedContent, setSelectedContant] = useState('');
  const [pendingSelectedContent, setPendingSelectedContant] = useState('');
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleCancel = () => {
    setIsConfirmOpen(false);
    setPendingFeild(null);
    setPendingSelectedContant('');
  };
  const handleConfirm = () => {
    if (pendingFeild) {
      setSelectedField(pendingFeild);
      setSelectedContant(pendingSelectedContent);
    }
    setIsConfirmOpen(false);
    setPendingFeild(null);
    setPendingSelectedContant('');
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Stack spacing={3} bgcolor={white} p={3} borderRadius={8} width="100%">
       {detailRows.map(({ label, messageKey }) => {
              const message =
                templateData[messageKey] || defaultMessages[messageKey];
      
              return (
                <Accordion
                  key={label}
                  expanded={expanded === messageKey}
                  sx={{
                    boxShadow: 'none !important',
                    borderRadius: '5px !important',
                    '&.MuiAccordion-root': {
                      cursor: 'default !important',
                      boxShadow: 'none',
                    },
                  }}
                >
                  <AccordionSummary
                    sx={{
                      cursor: 'default !important',
                      boxShadow: 'none !important',
                      borderRadius: '5px !important',
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100%"
                    >
                      <Typography fontWeight="bold">{label}</Typography>
                      <Stack direction="row" spacing={2} justifyContent="end">
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => {
                            setExpanded(expanded === messageKey ? false : messageKey);
                          }}
                        >
                          {expanded === messageKey ? 'Hide' : 'View'}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={(e) => {
                            if (isAppliedChanges) {
                              setPendingFeild(messageKey);
                              setPendingSelectedContant(templateData[messageKey] ? (templateData[messageKey] as string) : defaultMessages[messageKey]);
                              setIsConfirmOpen(true);
                              return;
                            }
                            e.stopPropagation();
                            setSelectedField(messageKey);
                            setSelectedContant(message);
                          }}
                        >
                          Edit
                        </Button>
                      </Stack>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ mb: 2 }}>
                       {parse(`In reference to your [position] application: ${message}`)}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              );
            })}
      {selectedField && (
        <TemplateUpdateDefaultMessageModal
          field={selectedField}
          content={selectedContent}
          templateData={templateData}
          handleClose={() => {
            setSelectedField(null)
            setSelectedContant('')
          }}
        />

      )}
      <ConfirmationModal
        open={isConfirmOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </Stack>
  );
};

export default TemplateApplicationResponsesTab;
